import gql from 'graphql-tag'

export const MUTATION_CREATE_BENEFIT_MOVEMENT_HISTORY_REPORT = gql`
  mutation CreateBenefitMovementHistoryReport($benefitId: String!, $fileFormat: FileFormatType, $emails: [String!]!) {
    createBenefitMovementHistoryReport(benefitId: $benefitId, fileFormat: $fileFormat, emails: $emails) {
      fileUrl
      id
      filesUrl
      state
      payload {
        benefitId
        emails
        fileFormat
      }
      title
    }
  }
`
export const UPSERT_BENEFIT = gql`
  mutation UpsertBenefit($input: InputUpsertBenefit!) {
    upsertBenefit(input: $input) {
      id
      status
      error
      createdAt
      updatedAt
    }
  }
`

export const UPSERT_DRAFT_BENEFIT = gql`
  mutation UpsertDraftBenefit($input: InputUpsertDraftBenefit!) {
    upsertDraftBenefit(input: $input) {
      id
      status
      error
      createdAt
      updatedAt
    }
  }
`

export const UNSCHEDULE_BENEFIT = gql`
  mutation UnscheduleBenefit($input: IdFilterInput!) {
    unscheduleBenefit(input: $input)
  }
`

export const DELETE_BENEFIT = gql`
  mutation DeleteBenefit($input: IdFilterInput!) {
    deleteBenefit(input: $input)
  }
`

export const CLONE_BENEFIT = gql`
  mutation CloneBenefit($input: IdFilterInput!) {
    cloneBenefit(input: $input)
  }
`

export const FINISH_ACTIVE_BENEFIT = gql`
  mutation FinishActiveBenefit($input: IdFilterInput!) {
    finishActiveBenefit(input: $input)
  }
`

export const QUERY_FIND_BENEFITS = gql`
  query FindPaginatedBenefits($input: FindPaginatedBenefitsInput!) {
    findPaginatedBenefits(input: $input) {
      page
      records
      benefits {
        _id
        title
        variableValidity
        # productsEnabled
        model
        status
        type
        code
        expiresAt
        startDate
        limitUse
        active
        daysToUseBenefitAfterRegistration
        value
        minimumValue
        units
        unitsInfo {
          id_erp
          name
        }
        products {
          name
          image
          sku
          eans
        }
        description
        brands {
          name
          image
        }
      }
    }
  }
`

export const QUERY_FIND_BENEFIT_BY_ID = gql`
  query FindBenefitById($id: String!, $franchise: Boolean) {
    findBenefitById(id: $id, franchise: $franchise) {
      _id
      title
      appTitle
      variableValidity
      minimumProducts
      model
      status
      type
      code
      expiresAt
      createdAt
      updatedAt
      startDate
      limitUse
      active
      daysToUseBenefitAfterRegistration
      value
      minimumValue
      units
      products {
        name
        image
        sku
        eans
        skuPerUnit
      }
      productsGroups {
        id
        name
        products {
          name
          image
          sku
          eans
          skuPerUnit
        }
        imageUrl
        rulesExhibition
      }
      description
      brands {
        name
        image
      }
      image
      draft
      finished
      sendWebhook
      offerScheduleId
      useApp
      segments
      isAutoActivated
      promoType
      minimumTriggerProductsValue
      segmentsData {
        _id
        name
        description
        fixed
        version
        campaignQty
        clientsQty
        clientsQtyAtCampaign
        clientsRefreshedAt
        createdAt
        updatedAt
      }
    }
  }
`

export const QUERY_FIND_BENEFIT_BY_ID_COMMUNICATE_CHANNEL = gql`
  query FindBenefitById($id: String!, $franchise: Boolean) {
    findBenefitById(id: $id, franchise: $franchise) {
      title
      description
      segments
      startDate
      expiresAt
      units
      segmentsData {
        _id
        name
        description
        fixed
        version
        campaignQty
        clientsQty
        clientsQtyAtCampaign
        clientsRefreshedAt
        createdAt
        updatedAt
      }
    }
  }
`

export const QUERY_VALIDATE_BENEFIT_CODE = gql`
  query ValidateBenefitCode($input: CodeFilterInput!) {
    validateBenefitCode(input: $input)
  }
`

export const QUERY_GENERATE_BENEFIT_CODE = gql`
  query GenerateRandomBenefitCode {
    generateRandomBenefitCode
  }
`
export const QUERY_BENEFIT_DISTRIBUTION = gql`
  query BenefitDistribution($input: InputBenefitDistribution!) {
    benefitDistribution(input: $input) {
      redeemedCoupons
      consumedCoupons
      activatedCoupons
      availableCoupons
    }
  }
`
export const QUERY_BENEFIT_MOVEMENT_HISTORY = gql`
  query BenefitMovementHistory($input: InputBenefitMovementHistory!) {
    benefitMovementHistory(input: $input) {
      page
      records
      benefitMovementHistory {
        unit {
          id: _id
          id_erp
          name
        }
        user {
          id
          documentNo
          name
        }
        createdAt
        couponId
        status
        saleCouponStatus
      }
    }
  }
`
export const QUERY_FIND_BENEFIT_METRICS_BY_ID = gql`
  query FindBenefitById($id: String!, $franchise: Boolean) {
    findBenefitById(id: $id, franchise: $franchise) {
      _id
      title
      appTitle
      variableValidity
      minimumProducts
      # productsEnabled
      model
      status
      metrics {
        clientsMetrics {
          consumedBenefits
          activatedBenefits
          redeemedBenefits
        }
        productsMetrics {
          table {
            tickets
            clients
            revenue
            quantity
            discounts
            averageTicket
            impact
            product {
              skuPerUnit
              eans
              sku
              name
            }
          }
          totals {
            impact
            averageTicket
            discounts
            revenue
            quantity
            clients
            tickets
          }
        }
        unitMetrics {
          table {
            tickets
            clients
            quantity
            revenue
            discounts
            averageTicket
            unit {
              id_erp
              name
            }
          }
        }
        benefitGeneralMetrics {
          revenue
          consumedCoupons
          averageTicket
          discountGranted
        }
      }
      type
      code
      expiresAt
      createdAt
      updatedAt
      startDate
      limitUse
      active
      segments
      daysToUseBenefitAfterRegistration
      value
      minimumValue
      units
      products {
        eans
        image
        name
        sku
      }
      productsGroups {
        id
        imageUrl
        name
        products {
          eans
          name
          sku
          image
        }
        rulesExhibition
      }
      description
      brands {
        image
        name
      }
      draft
      finished
      unitsInfo {
        id_erp
        name
      }
    }
  }
`
